export type ActivityEventName =
  | "nfc_entry_viewed"
  | "ad_viewed"
  | "promo_opened"
  | "registration_opened"
  | "registration_self_confirmed"
  | "wheel_started"
  | "wheel_completed"
  | "support_opened"
  | "flow_restarted";

export type ActivityEvent = {
  name: ActivityEventName;
  occurredAt: string;
  data?: Record<string, string | number | boolean>;
};

/**
 * 第一版只在瀏覽器內發出標準事件，不傳送個人資料。
 * 未來可在這一個位置串接後端、報表或個人 AI 系統，不必改動各畫面。
 */
export function trackActivity(
  name: ActivityEventName,
  data?: ActivityEvent["data"],
) {
  const event: ActivityEvent = {
    name,
    occurredAt: new Date().toISOString(),
    data,
  };

  window.dispatchEvent(new CustomEvent("914go:activity", { detail: event }));

  if (import.meta.env.DEV) {
    console.info("[914go activity]", event);
  }
}
